import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Iconify from '../../../components/Iconify';
import BackButton from '../../../components/BackButton';

const DetailField = ({ label, value }) => (
  <Stack gap={0.5}>
    <Typography variant="caption" color="#9CA3AF">
      {label}
    </Typography>
    <Typography variant="body1" color="#fff" sx={{ wordBreak: 'break-word' }}>
      {value || '--'}
    </Typography>
  </Stack>
);

const HistoryRowDialog = ({ open, onClose, row }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    PaperProps={{ sx: { backgroundColor: 'background.dialog' } }}>
    <DialogTitle sx={{ pr: 5 }}>
      History Entry
      <IconButton
        aria-label="Close"
        onClick={onClose}
        sx={{ position: 'absolute', right: 12, top: 12, color: '#CFCFCF' }}>
        <Iconify icon="mdi:close" width={20} height={20} />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <Box sx={{ pt: 1 }}>
        <Stack gap={2}>
          <DetailField label="Company Name" value={row?.companyName} />
          <DetailField label="Subscription Type" value={row?.subscriptionTypeLabel} />
          <DetailField label="Subscription Term" value={row?.subscriptionTermLabel} />
          <DetailField label="Support Tier" value={row?.supportTier} />
          <DetailField label="Licensed Devices" value={row?.licensedDeviceCount} />
          <DetailField label="Start Date" value={row?.subscriptionStartDateLabel} />
          <DetailField label="End Date" value={row?.subscriptionEndDateLabel} />
          <DetailField label="Changed By" value={row?.changedByUserEmail} />
          <DetailField label="Date" value={row?.historyDateLabel} />
        </Stack>
      </Box>
    </DialogContent>
    <DialogActions>
      <BackButton onClick={onClose}>Close</BackButton>
    </DialogActions>
  </Dialog>
);

HistoryRowDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default HistoryRowDialog;
